// extracted by mini-css-extract-plugin
module.exports = {"sweetenersList":"styles_sweetenersList__tVSkm"};